const contact = {
    title: 'ヘルプを得る',
    description: 'ヘルプ要求または製品フィードバックについては、次の方法を使用してお問い合わせください。',
    discord: {
        title: 'Discord コミュニティに参加する',
        description: '他の開発者と連携して解決策を見つける',
        button: '参加する',
    },
    github: {
        title: 'GitHub 上でコミュニケーションする',
        description: 'GitHubで問題を作成して提案する',
        button: '開く',
    },
    email: {
        title: 'メールでサポートに連絡する',
        description: '詳細情報やヘルプをご希望の場合は、私たちにメッセージを送ってください',
        button: '送信する',
    },
    reserve: {
        title: 'GptHouse チームとの会議を予約',
        description: 'ライブチャットのためにすぐにセッションを予約する',
        button: '予約する',
    },
};
export default Object.freeze(contact);
